import React from 'react';
import { COMPANY_NAME } from '../constants';

const Home = () => {
  return (
    <div
      className="h-screen bg-cover bg-center flex flex-col justify-center items-center text-white"
      style={{ backgroundImage: "url('https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=1470&q=80')" }}
    >
      <h2 className="text-5xl font-bold mb-4 drop-shadow-lg">Welcome to {COMPANY_NAME}</h2>
      <p className="text-xl mb-6 drop-shadow-lg">Your trusted partner in innovative software solutions.</p>
      <button
        onClick={() => alert('Thank you for your interest!')}
        className="bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-bold py-3 px-6 rounded shadow-lg transition duration-300"
      >
        Get Started
      </button>
    </div>
  );
};

export default Home;
